import { fork } from 'redux-saga/effects';
import {
  areaCoverageFlow,
  watchLatestCountiesFlow,
  addAreaCoverageFlow,
  deleteAreaCoverageFlow,
  updateAreaCoverageFlow,
  getCoverageState
} from './containers/AreaCoverage/saga';
import {
  companyInfoFlow,
  updateCompanyInfoFlow,
  getBannerData,
  getSFDCStats,
  updateAccountMangerInfo,
  getABFeatureList,
  getUserDetails,
  getImageBannerData,
  getApplicationNotificationsFlow,
  readApplicationNotificationFlow,
  markNotificationSeenFlow,
  getApplicationBySiteFlow,
  deleteApplicationNotificationFlow,
  requestSolargrafAccess,
  grantSolargrafAccess,
  getSolargrafSession,
  verifySolargrafSession,
  verifySolargrafEmail,
  getProjectDetails,
  getSiteDetailsFlow,
  canApplyDRSForCertificationCourseFlow,
  createDrsApplicationFlow,
  getEnlightenVersionFooterFlow
} from './containers/Layouts/saga';
import {
  getLeadsFlow,
  acceptLeadFlow,
  getLeadDetailsFlow,
  createQuoteFlow,
  quoteFileFlow,
  quoteUploadToS3Flow,
  quoteDownloadFromS3Flow,
  projectFileDownloadFromS3Flow,
  getPanelMfgFlow,
  getPanelModelFlow,
  getBOMListFlow,
  leadImagesFileFlow,
  getCartUrlFlow,
  getUpdateTaxAndShipmentFlow,
  getMasterAppliancesFlow,
  getSiteSearchLeadFlow,
  searchForSiteIdInLeadsFlow,
  linkSiteWithLeadFlow,
  getLeadDetailsFlowWithCallback,
  getLeadMessageListFlow,
  sendLeadMessage,
  leadMessagesFileFlow,
  watchLastPutS3Flow,
  getLeadAppointmentHistoryFlow,
  leadAcceptAppointmentFlow,
  leadCancelAppointmentFlow,
  leadRejectAppointmentFlow,
  leadRequestAppointmentFlow,
  getSystemDetails,
  unlinkSiteWithLeadFlow,
  getFinanceProvidersFlow,
  getContractPresignedURL,
  uploadContractToS3,
  saveContractFileDetailsInLeadJourney,
  getQuoteProposal,
  createSelfLeadFlow,
  getSiteSearchLeadsFlow,
  getLeadFromJourneyId,
  checkExistingEmailFlow,
  isAccountInEnlightenFlow,
  getSolargrafFinancials,
  getAllTemplatesFlow,
  saveTemplateFlow,
  createTemplateFlow,
  deleteTemplateFlow
} from './containers/LeadManagement/saga';
import {
  yelpLinkFlow,
  getStateList,
  getCompanyList,
  deleteCompanyLogo,
  updateCompanyLogo,
  googlePlaceIdFlow,
  updateRatingDetails
} from './containers/CompanyProfile/saga';
import { getBranchList, createBranch } from './containers/Branches/saga';
import { getUserList, createUser, getUserData } from './containers/Users/saga';
import { getUserPreferences, getUserPreferencesWithoutSites, updateUserPreferences, getUserOwnPreferencesFlow } from './containers/Preferences/saga';
import { getUserFeaturesSet } from './containers/PreferenceSettings/saga';
import { getAPIAccess, revokeAPIAccess } from './containers/APIAccess/saga';
import { getThirdPartList, updateThirdPartList } from './containers/ThirdPartyReporting/saga';
import {
  cancelEmailChangeFlow,
  getAccountData,
  resendConfirmationEmailFlow,
  resetPassword,
  getTrainingDashboardToken,
  getFleetDashboardLinkFlow,
  getApiKeyFlow,
  generateApiKeyFlow,
  getJobProfileList
} from './containers/AccountDetails/saga';
import {
  getDeviceTypes,
  getReplacementByDeviceType,
  confirmDeviceReplacement,
  getRMAStatus
} from './containers/DeviceReplacement/saga';
import { getGridList, getSelfInstallerGridList } from './containers/GridProfile/saga';
import {
  getCategoryList,
  createCategory,
  updateSKU,
  deleteSKU,
  deleteCategory,
  updateCategoryType,
  getSKUList
} from './containers/PlatformDiscounts/saga';
import {
  getAllSystemList,
  getAllDashboardList,
  getAllActivationList,
  getAllAlertList,
  getSearchData,
  getEnlmFeedback,
  addEnlmFeedback,
  getGridProfileToken,
  getSystemSavedSearch,
  getFilteredList,
  getServiceManagerCases
} from './containers/Dashboard/saga';
import {
  getLREPlansFlow,
  getSiteListsFlow,
  getLREItems,
  updateLREItems,
  addItemsToCart,
  getSelectedItems,
  getPlansBySiteId,
  createSystem,
  getAgreementFileFlow
} from './containers/Systems/saga';
import {
  getProntoProviderStatusFlow,
  createProntoProviderFlow,
  getInstallerInfoFlow
} from './containers/Pronto/saga';
// import {
//   createPermitProjectDetails,
//   getPermittingRequestsListingFlow,
//   getSiteSearchFlow,
//   siteDetailsFlow,
//   getMaterialDetails,
//   updateMaterialDetails,
//   getFileLinkFlow,
//   watchLastPutS3Flow,
//   getUserSelectionData,
//   getPermitProjectDetailsFlow,
//   getPermitPaymentIntentFlow,
//   getStripePublishableKeyFlow,
//   updatePermitPaymentDetailsFlow,
//   getAllServices,
//   getSelectedServices,
//   updateSelectedServices,
//   getPermittingById,
//   getPanelManufacturerListFlow,
//   applyPromocodeFlow,
//   getMessageListFlow,
//   watchLastMessageFlow,
//   updateStateFlow,
//   getRackingMfs,
//   getUtilityProvidersFlow,
//   getSelectedSites,
//   getChatInfoFlow,
//   chatStatusUpdateFlow,
//   getReworkServices,
//   updateReworkServices,
//   getSelectedReworkServices,
//   getApplicationBySiteFlow
// } from './containers/Permitting/saga';
import { getSgipSiteListFlow, getSiteSearchFlow } from './containers/SGIPIncentive/saga';
import {
  getAllAdminPanelDetails,
  getAdminDetails,
  createAdminDetails,
  updateAdminDetails,
  deleteAdminDetails,
  getProductAccessList,
  einOptOut,
  einDataUpload,
  getSampleFileFields,
  watchLastEinPutS3Flow,
  getEnlmFeedbacksCsvData
} from './containers/EinAdmin/saga';
import {
  getDigitalAssets,
  getHeaderbarLinks,
  getExclusiveUpdatesLinks,
  getProductInformation,
  updateProductInformation,
  getAllDetails,
  getNpsFeedbacks,
  getNpsRatings,
  getDashboardStats,
  productSignup,
  getSEUrl,
  updateSEUrl
} from './containers/EinDashboard/saga';
import { storeCreditFileUpload, getSampleFileMerchandise } from './containers/MerchandiseCredit/saga';
import {
  getAllEnlightenNoticesFlow,
  populateEnlightenNoticeFlow,
  deleteEnlightenNoticeFlow,
  getNoticeS3UrlFlow,
  emailIdFlow,
  deleteImageS3UrlFlow,
  getRevenueReportFileFlow,
  updateServiceRolesFlow,
  getServiceRolesFlow
} from './containers/AdminNew/saga';

import {
  signUp,
  resendRegistrationOtp,
  setPassword,
  getCountryList,
  validateCompanyData
} from './containers/Registration/saga';
import {
  addAuthorizedDealerFlow,
  authorizedDealerStatusUpdateFlow,
  getAuthDealerCountryListFlow,
  getDealerListFlow,
  searchDealerFlow
} from './containers/AuthorizedDealer/saga';
import { getGeneratorTokenInstallerListFlow, getGeneratorTokenInstallerListBulkFlow, getSubcontractorListFlow, assignTokensToSubcontractorFlow, getStoreUrlFlow } from './containers/GeneratorTokensInstaller/saga'

import { getGeneratorTokenDistributorListFlow, getGeneratorTokenDistributorListBulkFlow, searchInstallerFlow, assignTokensToInstallerFlow, assignTokensToDistributorFlow } from './containers/GeneratorTokensDistributor/saga'

import { getSolargrafProjectDetailsFlow, getSolargrafProjectsFlow } from './containers/BOM/saga';
import { FormLabel } from '@material-ui/core';
import { getInstallerSearch } from './containers/GeneratorTokensDistributor/actions';

import { getCellModemListFlow, extendDataPlanFlow, getPricesFlow, getPostFeedbackForm, getFeedbackGiven } from './containers/CellModemDataPlanExtension/saga';

export default function* root() {
  yield fork(areaCoverageFlow);
  yield fork(watchLatestCountiesFlow);
  yield fork(addAreaCoverageFlow);
  yield fork(deleteAreaCoverageFlow);
  yield fork(updateAreaCoverageFlow);
  yield fork(getCoverageState);

  yield fork(companyInfoFlow);
  yield fork(updateCompanyInfoFlow);
  yield fork(getBannerData);
  yield fork(getSFDCStats);
  yield fork(updateAccountMangerInfo);
  yield fork(getABFeatureList);
  yield fork(getUserDetails);
  yield fork(getImageBannerData);
  yield fork(getApplicationNotificationsFlow);
  yield fork(readApplicationNotificationFlow);
  yield fork(markNotificationSeenFlow);
  yield fork(getApplicationBySiteFlow);
  yield fork(deleteApplicationNotificationFlow);
  yield fork(requestSolargrafAccess);
  yield fork(grantSolargrafAccess);
  yield fork(getSolargrafSession);
  yield fork(verifySolargrafSession);
  yield fork(verifySolargrafEmail);
  yield fork(getProjectDetails);
  yield fork(getSiteDetailsFlow);
  yield fork(canApplyDRSForCertificationCourseFlow);
  yield fork(createDrsApplicationFlow);

  yield fork(getLeadsFlow);
  yield fork(acceptLeadFlow);
  yield fork(getLeadDetailsFlow);
  yield fork(createQuoteFlow);
  yield fork(quoteFileFlow);
  yield fork(quoteUploadToS3Flow);
  yield fork(quoteDownloadFromS3Flow);
  yield fork(projectFileDownloadFromS3Flow);
  yield fork(getPanelMfgFlow);
  yield fork(getPanelModelFlow);
  yield fork(getBOMListFlow);
  yield fork(leadImagesFileFlow);
  yield fork(getCartUrlFlow);
  yield fork(getUpdateTaxAndShipmentFlow);
  yield fork(getMasterAppliancesFlow);
  yield fork(getSiteSearchLeadFlow);
  yield fork(searchForSiteIdInLeadsFlow);
  yield fork(linkSiteWithLeadFlow);
  yield fork(getLeadDetailsFlowWithCallback);
  yield fork(getLeadMessageListFlow);
  yield fork(sendLeadMessage);
  yield fork(leadMessagesFileFlow);
  yield fork(watchLastPutS3Flow);
  yield fork(getLeadAppointmentHistoryFlow);
  yield fork(leadAcceptAppointmentFlow);
  yield fork(leadCancelAppointmentFlow);
  yield fork(leadRejectAppointmentFlow);
  yield fork(leadRequestAppointmentFlow);
  yield fork(getSystemDetails);
  yield fork(unlinkSiteWithLeadFlow);
  yield fork(getFinanceProvidersFlow);
  yield fork(getContractPresignedURL);
  yield fork(uploadContractToS3);
  yield fork(saveContractFileDetailsInLeadJourney);
  yield fork(getQuoteProposal);
  yield fork(createSelfLeadFlow);
  yield fork(getSiteSearchLeadsFlow);
  yield fork(getLeadFromJourneyId);
  yield fork(checkExistingEmailFlow);
  yield fork(isAccountInEnlightenFlow);
  yield fork(getSolargrafFinancials);
  yield fork(getAllTemplatesFlow);
  yield fork(saveTemplateFlow);
  yield fork(createTemplateFlow);
  yield fork(deleteTemplateFlow);

  yield fork(getLREPlansFlow);
  yield fork(getSiteListsFlow);
  yield fork(getLREItems);
  yield fork(updateLREItems);
  yield fork(addItemsToCart);
  yield fork(getSelectedItems);
  yield fork(getPlansBySiteId);
  yield fork(createSystem);
  yield fork(getAgreementFileFlow);

  yield fork(yelpLinkFlow);
  yield fork(getStateList);
  yield fork(getCompanyList);
  yield fork(deleteCompanyLogo);
  yield fork(updateCompanyLogo);
  yield fork(googlePlaceIdFlow);
  yield fork(updateRatingDetails);

  yield fork(getBranchList);
  yield fork(createBranch);

  yield fork(getUserList);
  yield fork(createUser);
  yield fork(getUserData);

  yield fork(getUserPreferences);
  yield fork(getUserPreferencesWithoutSites);
  yield fork(updateUserPreferences);
  yield fork(getUserOwnPreferencesFlow);

  yield fork(getUserFeaturesSet);

  yield fork(getAPIAccess);
  yield fork(revokeAPIAccess);

  yield fork(getThirdPartList);
  yield fork(updateThirdPartList);

  yield fork(getAccountData);
  yield fork(resetPassword);
  yield fork(resendConfirmationEmailFlow);
  yield fork(cancelEmailChangeFlow);
  yield fork(getTrainingDashboardToken);
  yield fork(getFleetDashboardLinkFlow);
  yield fork(getEnlightenVersionFooterFlow);
  yield fork(getApiKeyFlow);
  yield fork(generateApiKeyFlow);
  yield fork(getJobProfileList);

  yield fork(getGridList);
  yield fork(getSelfInstallerGridList);

  yield fork(getCategoryList);
  yield fork(createCategory);
  yield fork(updateSKU);
  yield fork(deleteSKU);
  yield fork(deleteCategory);
  yield fork(updateCategoryType);
  yield fork(getSKUList);

  yield fork(getAllSystemList);
  yield fork(getAllDashboardList);
  yield fork(getAllActivationList);
  yield fork(getAllAlertList);
  yield fork(getSearchData);
  yield fork(getEnlmFeedback);
  yield fork(addEnlmFeedback);
  yield fork(getGridProfileToken);
  yield fork(getSystemSavedSearch);
  yield fork(getFilteredList);
  yield fork(getServiceManagerCases);
  yield fork(getProntoProviderStatusFlow);
  yield fork(createProntoProviderFlow);
  yield fork(getInstallerInfoFlow);
  // yield fork(createPermitProjectDetails);
  // yield fork(getPermittingRequestsListingFlow);
  // yield fork(getFileLinkFlow);
  // yield fork(watchLastPutS3Flow);
  // yield fork(getSiteSearchFlow);
  // yield fork(siteDetailsFlow);
  // yield fork(getPanelManufacturerListFlow);
  // yield fork(updateMaterialDetails);
  // yield fork(getMaterialDetails);
  // yield fork(getUserSelectionData);
  // yield fork(getPermitProjectDetailsFlow);
  // yield fork(getPermitPaymentIntentFlow);
  // yield fork(getStripePublishableKeyFlow);
  // yield fork(updatePermitPaymentDetailsFlow);
  // yield fork(getAllServices);
  // yield fork(getSelectedServices);
  // yield fork(updateSelectedServices);
  // yield fork(getPermittingById);
  // yield fork(applyPromocodeFlow);
  // yield fork(getMessageListFlow);
  // yield fork(watchLastMessageFlow);
  // yield fork(updateStateFlow);
  // yield fork(getRackingMfs);
  // yield fork(getUtilityProvidersFlow);
  // yield fork(getSelectedSites);
  // yield fork(getChatInfoFlow);
  // yield fork(chatStatusUpdateFlow);
  // yield fork(getReworkServices);
  // yield fork(updateReworkServices);
  // yield fork(getSelectedReworkServices);
  // yield fork(getApplicationBySiteFlow);

  yield fork(getSgipSiteListFlow);
  yield fork(getSiteSearchFlow);

  yield fork(getAllAdminPanelDetails);
  yield fork(getAdminDetails);
  yield fork(createAdminDetails);
  yield fork(updateAdminDetails);
  yield fork(deleteAdminDetails);
  yield fork(getProductAccessList);
  yield fork(einDataUpload);
  yield fork(getSampleFileFields);
  yield fork(watchLastEinPutS3Flow);
  yield fork(einOptOut);
  yield fork(getEnlmFeedbacksCsvData);

  yield fork(getAllDetails);
  yield fork(getDigitalAssets);
  yield fork(getHeaderbarLinks);
  yield fork(getExclusiveUpdatesLinks);
  yield fork(getProductInformation);
  yield fork(updateProductInformation);
  yield fork(getNpsFeedbacks);
  yield fork(getNpsRatings);
  yield fork(productSignup);
  yield fork(getSEUrl);
  yield fork(updateSEUrl);

  yield fork(storeCreditFileUpload);
  yield fork(getSampleFileMerchandise);
  yield fork(getDashboardStats);

  yield fork(getAllEnlightenNoticesFlow);
  yield fork(populateEnlightenNoticeFlow);
  yield fork(deleteEnlightenNoticeFlow);
  yield fork(getNoticeS3UrlFlow);
  yield fork(emailIdFlow);
  yield fork(deleteImageS3UrlFlow);
  yield fork(getRevenueReportFileFlow);
  yield fork(updateServiceRolesFlow);
  yield fork(getServiceRolesFlow);

  yield fork(signUp);
  yield fork(resendRegistrationOtp);
  yield fork(setPassword);
  yield fork(getCountryList);
  yield fork(validateCompanyData);
  yield fork(getDealerListFlow);

  yield fork(getGeneratorTokenInstallerListFlow);
  yield fork(getGeneratorTokenInstallerListBulkFlow);
  yield fork(assignTokensToSubcontractorFlow);
  yield fork(getSubcontractorListFlow);
  yield fork(getStoreUrlFlow);

  yield fork(getGeneratorTokenDistributorListFlow);
  yield fork(getGeneratorTokenDistributorListBulkFlow);
  yield fork(searchInstallerFlow);
  yield fork(assignTokensToInstallerFlow);
  yield fork(assignTokensToDistributorFlow);

  yield fork(searchDealerFlow);
  yield fork(addAuthorizedDealerFlow);
  yield fork(authorizedDealerStatusUpdateFlow);
  yield fork(getAuthDealerCountryListFlow);

  yield fork(getSolargrafProjectsFlow);
  yield fork(getSolargrafProjectDetailsFlow);

  yield fork(getCellModemListFlow);
  yield fork(extendDataPlanFlow);
  yield fork(getPricesFlow);
  yield fork(getPostFeedbackForm);
  yield fork(getFeedbackGiven);
  yield fork(getDeviceTypes);
  yield fork(getReplacementByDeviceType);
  yield fork(confirmDeviceReplacement);
  yield fork(getRMAStatus);
}